import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListInjuryNatures } from "../../../components/Admin/InjuryNatures/ListInjuryNatures/ListInjuryNatures";
import { useLanguage } from "../../../contexts";
import "./InjuryNatures.scss";

export function InjuryNatures() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("actives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListInjuryNatures active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListInjuryNatures active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="injury-natures-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="injury-natures-page-header-wrapper">
        <div className="injury-natures-page-header">
          <span className="injury-natures-page-title">{t("injury_natures")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
